module.exports = __webpack_public_path__ + "media/dice.141a2eb2.wav";